"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var chartSection_styles_1 = require("./chartSection.styles");
var sectionTitlesTooltip_1 = require("../section-titles-tooltip/sectionTitlesTooltip");
var errorBoundary_1 = require("../error/errorBoundary");
exports.ChartSection = function (props) {
    var tooltipProps = {
        id: props.id + "-tooltip",
    };
    if (props.info && typeof props.info === "string") {
        tooltipProps["text"] = props.info;
    }
    else {
        tooltipProps["html"] = props.info;
    }
    return (React.createElement("div", { className: chartSection_styles_1.container, id: props.id, "data-qa": "chart-section" },
        React.createElement(errorBoundary_1.ErrorBoundary, null,
            React.createElement("div", { className: chartSection_styles_1.heading, id: props.id + "-heading" },
                React.createElement("div", null, props.heading),
                props.info && (React.createElement("div", { className: chartSection_styles_1.image },
                    React.createElement(sectionTitlesTooltip_1.SectionTitlesTooltip, __assign({}, tooltipProps))))),
            React.createElement("div", { className: chartSection_styles_1.chartWrapper }, props.children))));
};
